import { createAction } from 'redux-actions';
import { take, race } from 'redux-saga/effects';

/* 
Helper for return bundle of typical actions like
MYDATA, REQUEST/MYDATA, REQUEST/MYDATA_SUCCESS, REQUEST/MYDATA_FAILURE
*/
export const createActionBundle = type => ({
  fetch: createAction(`FETCH/${type}`),
  request: createAction(`REQUEST/${type}`),
  success: createAction(`REQUEST/${type}_SUCCESS`),
  failure: createAction(`REQUEST/${type}_FAILURE`),
});

export const createSagaRace = type =>
  race({
    failure: take(`${type}_FAILURE`),
    success: take(`${type}_SUCCESS`),
  });

export const createFailureAction = action => {
  const actionName = action.toString();
  return createAction(`${actionName}_FAILURE`);
};

export const createSuccessAction = action => {
  const actionName = action.toString();
  return createAction(`${actionName}_SUCCESS`);
};

export const createSagaRequestRace = action => ({
  failure: take(createFailureAction(action)),
  success: take(createSuccessAction(action)),
});
